import { Button, ButtonGroup, Modal } from '@zillow/constellation-10';
import { useContext } from 'react';
import type { ErrorWizardStep, WizardStep } from '../wizard/wizardTypes';
import { WizardContext } from '../wizard/WizardContext';
import {
  wizardContainerStyles,
  wizardFooterButtonStyles,
  wizardFooterEndStyles,
  wizardFooterSpaceBetweenStyles,
  wizardFooterStyles,
} from './wizardShellStyles';

export default function Footer({ isInitializing, isBusy }: { isInitializing: boolean; isBusy: boolean }) {
  const { goToNextStep, goToPreviousStep, currentStep, currentIndex, onNext, isNextDisabled, isBackDisabled } =
    useContext(WizardContext);
  const displayBackButton =
    typeof currentIndex === 'number' && currentIndex > 0 && ((currentStep as WizardStep).renderBackButton ?? true);

  return (
    <Modal.Footer css={wizardFooterStyles}>
      <ButtonGroup
        aria-label="Wizard navigation"
        fluid={{ base: true, lg: false }}
        css={{
          ...wizardContainerStyles,
          ...(displayBackButton ? wizardFooterSpaceBetweenStyles : wizardFooterEndStyles),
        }}
      >
        {displayBackButton && (
          <Button
            tone="neutral"
            emphasis="outlined"
            css={wizardFooterButtonStyles}
            onClick={goToPreviousStep}
            disabled={isInitializing || isBusy || isBackDisabled}
          >
            Back
          </Button>
        )}
        <Button
          tone="brand"
          emphasis="filled"
          css={wizardFooterButtonStyles}
          onClick={onNext ?? goToNextStep}
          loading={!isInitializing && isBusy}
          disabled={isInitializing || isNextDisabled}
        >
          {(currentStep as WizardStep | ErrorWizardStep).nextButtonText || 'Next'}
        </Button>
      </ButtonGroup>
    </Modal.Footer>
  );
}
